<template>
  <div>
    <Container class="container-sm-none">
      <Progressbar :step="childrenWithIndexes.length > 0 ? 11 : 8" :step-count="model.stepCount">
        Health Insurance Card Delivery
      </Progressbar>
      <Card class="card-shadow">
        <div class="width-lg">
          <div class="pl-10 pl-md-0 pr-10 pr-md-0">
            <div class="flex justify-left justify-md-center align-center pb-10 pb-md-15">
              <h3 class="weight-medium text-left pr-6">
                Select a Delivery Method
                <Tooltip slot="tooltip">
                  <p class="text-left m-0">
                    
    You can also use <b>delivery by post</b>, if you are not a permanent resident of the Slovak Republic or do not hold Slovak citizenship.
    <br/>
    <br/>
    In that case, you can also select your employer's address as the mailing address.
    <br/>
    <br/>
    It is possible to <b>collect the health insurance card</b> in person in the month of December if the policyholder is changing health insurance providers.
  
                  </p>
                </Tooltip>
              </h3>
            </div>

            <DeliveryComponent
              :person="model.insuredPersons.array_hd7ov6$_0[0]"
              :card-delivery="model.cardDelivery"
              :insurer="model.insurer"
              :errors="errors"
            />

            <ButtonGroup class="pt-20">
              <Button
                class="btn-outline-tertiary w-full"
                :icon-left="require('@/assets/svg/icon-left-gray.svg')"
                @click="redirectBack"
              >
                Back
              </Button>
              <Button
                class="btn-primary w-full"
                :icon-right="require('@/assets/svg/icon-right-white.svg')"
                @click="redirectToNext"
                v-scroll-to-error
              >
                Continue
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </Card>
    </Container>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue';
import Container from '@/components/Container/Container.vue';
import Progressbar from '@/components/Progressbar/Progressbar.vue';
import Button from '@/components/Button/Button.vue';
import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue';
import routes from '@/mixins/routes';
import enums from '@/mixins/enums';
import DeliveryComponent from '@/pagesComponents/DeliveryComponent.vue';
import address from '@/mixins/address';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import lead from '@/mixins/lead';
import persons from '@/mixins/persons';
import GA from '@/mixins/GA';

export default {
  name: 'PassDeliveryPage',
  mixins: [routes, enums, address, lead, persons, GA],
  components: {
    DeliveryComponent,
    ButtonGroup,
    Button,
    Card,
    Container,
    Progressbar,
    Tooltip,
  },
  props: {
    errors: { type: Array, required: true },
    model: { type: Object, required: true },
  },
  methods: {
    redirectToNext() {
      if (this.errors.length === 0) {
        this.saveLead(this.getNearestNextAvailableStep());
        if (!this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(this.getNearestNextAvailableStep())) {
          this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(this.getNearestNextAvailableStep());
        }
        this.model.currentPersonStepIndex += 1;
        this.$router.goToStep(this.getNearestNextAvailableStep());
      }
    },
    redirectBack() {
      this.$router.goToStep(this.getNearestPreviousAvailableStep());
    },
  },
  created() {
    this.model.step = 17;
    if (this.model.lastStep < 17) this.model.lastStep = 17;
  },
  mounted() {
    this.funnelStep('Doručenie preukazu poistenca');
  },
};
</script>
